import Filterable from '@ui/Filterable'

export interface InitialPayment {
	amount: number
	request_id: string
}

export default class BillingRequest implements Filterable {
	constructor(
		public auth_url: string,
		public redirect_uri: string,
		public exit_uri: string,
	) {}

	public getFilterName = (): string => {
		return ''
	}

	public reset = (): Filterable => {
		return undefined
	}

	public toFilter = (): any => {
		return {}
	}
}
